module.exports = __webpack_public_path__ + "img/unlocked.26954409.svg";